import ImageHolder from "@@/core/components/shared/ImageHolder/ImageHolder";
import { BButton } from "bootstrap-vue";

export default {
  name: "ProductImages",
  components: { ImageHolder, BButton },
  props: {
    value: Array,
    hideShadow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isDragging: false,
      realValue: this.value,
    };
  },
  watch: {
    value: function(newVal) {
      this.realValue = newVal;
    },
    realValue: function(newVal) {
      this.$emit("input", newVal);
    },
  },
  mounted() {
  },
  methods: {
   
    fileAdded(e) {
      Array.from(e.target.files).forEach((_file) => {
        this.addImage(_file);
      });
    },

    addImage(_file) {
      if (!_file.type.includes("image")) {
        return;
      }
      const reader = new FileReader();
      reader.readAsDataURL(_file);
      reader.onload = (file) => {
        const srcBase64 = file.target.result;
        const image = {
          url: srcBase64,
          file:_file,
          key: this.$root.uniqueId(),
        };
        this.realValue.push(image);
        this.$refs.fileInput.value = "";
      };
    },
    deleteImage(key) {
      this.$emit("addToDeletedList", key);
    },
  },
};
